import React, { useEffect, useRef, useState } from 'react';
import MobilePdfViewer from '../MiningReportLanding/MobilePdfViewer';

const RobBruggemannsMetalsPlaybook: React.FC = () => {
  const pdfUrl = '/reports/Special_Report.pdf';
  const playbookPageUrl = `${window.location.origin}/rob-bruggemanns-2026-metals-playbook`;
  const [copyMessage, setCopyMessage] = useState('');
  const copyMessageTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (copyMessageTimeoutRef.current) {
        window.clearTimeout(copyMessageTimeoutRef.current);
      }
    };
  }, []);

  const showCopyMessage = (message: string) => {
    setCopyMessage(message);
    if (copyMessageTimeoutRef.current) {
      window.clearTimeout(copyMessageTimeoutRef.current);
    }
    copyMessageTimeoutRef.current = window.setTimeout(() => {
      setCopyMessage('');
    }, 2200);
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(playbookPageUrl);
      showCopyMessage('Playbook page link copied. You can now share it.');
    } catch {
      window.prompt('Copy this page link:', playbookPageUrl);
    }
  };

  return (
    <div className="relative w-full overflow-hidden bg-[#0f1a31]">
      <div className="px-4 py-3 sm:px-6 sm:py-4 border-b border-white/15">
        <div className="max-w-[1280px] mx-auto flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <h1 className="text-white text-[16px] sm:text-[18px] font-[700] tracking-[0.02em] leading-tight">
            Rob Bruggemanns&apos; 2026 Metals Playbook
          </h1>
          <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3">
            <a
              href={pdfUrl}
              download="Special Report.pdf"
              className="h-[42px] px-4 inline-flex items-center justify-center rounded-[8px] bg-[#c49a2d] text-[#0f1a31] font-[700] text-[14px]"
            >
              Download
            </a>
            <button
              type="button"
              onClick={handleCopyUrl}
              className="h-[42px] px-4 inline-flex items-center justify-center rounded-[8px] border border-white/35 text-white font-[700] text-[14px]"
            >
              Copy URL
            </button>
          </div>
        </div>
      </div>

      <div
        className="relative z-10 w-full border-0"
        style={{
          height: 'calc(100dvh - 76px)',
          minHeight: '-webkit-fill-available',
        }}
      >
        <MobilePdfViewer pdfUrl={pdfUrl} openLinksInNewTab={true} />
      </div>

      {copyMessage && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-30 px-4 py-2 rounded-full bg-[#c49a2d] text-[#0f1a31] text-[13px] sm:text-[14px] font-[700] shadow-lg">
          {copyMessage}
        </div>
      )}
    </div>
  );
};

export default RobBruggemannsMetalsPlaybook;
